import style from './index.module.scss'

interface IProps {
  className?: string
  children: React.ReactNode
}

export const H2: React.FC<IProps> = ({ children, className }) => {
  return (
    <h2
      className={tw`text-center text-xl font-bold md:text-4xl ${style.heightLightText} ${className}`}
    >
      {children}
    </h2>
  )
}
